import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";

const PRODUCT_ID = GetItemFromStorage(LocalStorage.PRODUCT_ID);


export const checkIfExist = (store: any, item: any) => {
  return store.skill?.findIndex((user: any) => user?.key === item);
};

export const addSkills = (data: any) => {
  let skills = JSON.parse(data?.addSkill);
  let skillValue: any =
    skills?.length > 0 ? skills?.map((elem: any) => elem) : [];
  return skillValue;
};

export const showErrros = (data: any) => {
  let showError = false;
  if (
    data?.voice === 0 &&
    data?.chat === 0 &&
    data?.email === 0 &&
    data?.sms === 0 &&
    data?.socialMedia === 0
  ) {
    showError = true;
  } else {
    showError = false;
  }
  return showError;
};
export const setchannelList = (data: any) => {
  return {
    sms: data.sms,
    socialMedia: data.socialMedia,
    voice: data.voice,
    email: data.email,
    chat: data.chat,
  };
};

export const routingProfile = (data: any) => {
  return {
    value: data.routing_profile_name,
    key: data.routing_profile,
  };
};
export const skill = (data: any) => {
  let skillValue = addSkills(data);
  let skillS: any = [];
  skillValue?.map((skill: any) => {
    skillS?.push({
      skid: skill?.skid,
      value: skill?.value,
    });
  });
  return skillS;
};

export const reportTo = (data: any) => {
  return {
    value: data.reporting_to_name,
    key: data.report_to_UserID,
  };
};

export const outBoundCall = (data: any) => {
  return data.callTypeId;
};
export const callHandling = (data: any) => {
  if (data?.inboundCall && data?.callTypeId) {
    return 3;
  } else if (data?.callTypeId) {
    return 2;
  }  else if (data?.inboundCall) {
    return 1;
  } else if (data?.outboundCampaignCall) {
    return 4;
  } else if (data?.is_outbound_campaign_specific_agent) {
    return 5;
  } else {
    return 0; // default case if none match
  }
};


export const getChannelsAddOnList = (data: any) => {
  let res = [] as any
  if(PRODUCT_ID && data.length > 0){
    data?.forEach((d :any) => {
      if(['Email','SMS'].includes(d.addon_feature_name)){
          res.push(d.addon_feature_name)
      }
    });
  }
  return res
};
